import { Routes } from '@angular/router';
import { BasicComponent } from './common/layouts/basic/basic.component';
import { BlankComponent } from './common/layouts/blank/blank.component';
import { HomeComponent } from './views/home/home.component';
import { HoteliersPermitsSigninComponent } from './views/hoteliers-permits/hoteliers-permits-signin/hoteliers-permits-signin.component';
import { HoteliersStayManagementComponent } from './views/hoteliers-permits/hoteliers-stay-management/hoteliers-stay-management.component';
// tslint:disable-next-line:max-line-length
import { HoteliersStructuresManagementComponent } from './views/hoteliers-permits/hoteliers-structures-management/hoteliers-structures-management.component';
import { HoteliersStructuresListComponent } from './views/hoteliers-permits/hoteliers-structures-list/hoteliers-structures-list.component';
// tslint:disable-next-line:max-line-length
import { HoteliersStructuresRoomsComponent } from './views/hoteliers-permits/hoteliers-structures-rooms/hoteliers-structures-rooms.component';
// tslint:disable-next-line:max-line-length
import { HoteliersPermitsCalendarComponent } from './views/hoteliers-permits/hoteliers-permits-calendar/hoteliers-permits-calendar.component';
import { HoteliersPaymentComponent } from './views/hoteliers-permits/hoteliers-payment/hoteliers-payment.component';
import { TargheManageComponent } from './views/targhe/targhe-manage/targhe-manage.component';
import { VoucherCovidListComponent } from './views/voucher-covid/voucher-covid-list/voucher-covid-list.component';
import { VoucherCovidManageComponent } from './views/voucher-covid/voucher-covid-manage/voucher-covid-manage.component';
import { VoucherRedeemComponent } from './views/voucher/voucher-redeem/voucher-redeem.component';
import { AtbPayPaymentMethodsListComponent } from './views/atb-pay/payment-methods-list/atb-pay-payment-methods-list.component';
import { MobileAppPaymentErrorComponent } from './views/mobile-app/payment-error/mobile-app-payment-error.component';


export const ROUTES: Routes = [
  // Main redirect
  {path: '', redirectTo: 'home', pathMatch: 'full'}, //VA FATTA UNA 404??

  // App views
 /* {
    path: '', component: BlankComponent,
    children: [
      { path: 'test1', component: OrderEditComponent },
      { path: 'test1/:id', component: OrderEditComponent },
      { path: 'test2', component: OrdersListComponent },
      { path: 'test3/:id', component: SupplierDetailsComponent}
    ]
  }, */
  {
    path: '', component: BasicComponent,
    children: [
      { path: 'home', component: HomeComponent },
      { path: 'hoteliers/structure/structures', component: HoteliersStructuresListComponent},
      { path: 'hoteliers/signin', component: HoteliersPermitsSigninComponent},
      { path: 'hoteliers/manage', component: HoteliersStayManagementComponent},
      { path: 'targhe/manage', component: TargheManageComponent},
      { path: 'hoteliers/structure/new', component: HoteliersStructuresManagementComponent},
      { path: 'hoteliers/structure/edit', component: HoteliersStructuresManagementComponent},
      { path: 'hoteliers/structure/rooms', component: HoteliersStructuresRoomsComponent},
      { path: 'hoteliers/permits/calendar', component: HoteliersPermitsCalendarComponent},
      { path: 'hoteliers/payment', component: HoteliersPaymentComponent},
      { path: 'hoteliers/structure/structures/:token/:user/:role/:language', component: HoteliersStructuresListComponent},
      /* { path: 'voucher-covid/:token/:user/:role/:language', component: VoucherCovidListComponent},
      { path: 'voucher-covid/list', component: VoucherCovidListComponent},
      { path: 'voucher-covid/manage', component: VoucherCovidManageComponent} */
      /* { path: 'voucher/:token/:user/:role/:language', component: VoucherRedeemComponent},
      { path: 'voucher/redeem', component: VoucherRedeemComponent} */
      { path: 'atb-pay/payment-methods/:token/:user/:role/:language', component: AtbPayPaymentMethodsListComponent},
      { path: 'atb-pay/payment-methods/list', component: AtbPayPaymentMethodsListComponent}
    ]
  },
  {
    path: '', component: BlankComponent,
    children: [
      { path: 'mobile-app/payment-error', component: MobileAppPaymentErrorComponent }
    ]
  },
  // Handle all other routes
  {path: '**',  redirectTo: 'home', pathMatch: 'full' }
] ;



// WEBPACK FOOTER //
// ./src/app/app.routes.ts